<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" md="4" xs="12" sm="12">
        <v-text-field
          autocomplete="off"
          type="text"
          dense
          outlined
          label="Account Name"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4" xs="12" sm="12">
        <v-autocomplete
          automplete="off"
          dense
          outlined
          v-model="record.CategoryId"
          :items="categories"
          label="Account Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete
          autocomplete="off"
          name="owner"
          hide-details
          dense
          outlined
          v-model="record.Owner"
          :items="owners"
          label="Owner"
          item-text="name"
          item-value="id"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="4">
        <v-radio-group
          dense
          label="Banking Account"
          v-model="BankAccount"
          row
        >
          <v-radio label="Yes" value="Y"></v-radio>
          <v-radio label="No" value="N"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="12" xs="12" sm="12">
        <v-btn
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon> Create Account
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    createDoc: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    BankAccount: "N",
    owners: [],
    accountTypes: [
      { name: "Cash", value: "C" },
      { name: "Mpesa", value: "M" },
      { name: "Bank", value: "B" },
      { name: "Float", value: "F" },
    ],
    categories: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      if(val.BankAccount == 1) {
        this.BankAccount = "Y";
      }

      if(val.BankAccount == 0) {
        this.BankAccount = "N";
      }

      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
        this.$store.commit("btnLoader", true);
        this.record.BankAccount = this.BankAccount == "Y" ? 1 : 0;
        this.$emit("data", this.record);
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/account-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/get-owner-users`)
        .then(res => {
          console.log(res.ResponseData);
          self.owners = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getCategories();
    this.getOwners();
  },
};
</script>